import { useState } from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'

import Select from 'modules/core/components/SelectField'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import type { TagInfoProp } from 'modules/org_chart/models/TagInfoProp'
import { tagInfoProps } from 'modules/org_chart/models/TagInfoProp'

interface Props {
  initialValue: TagInfoProp
  onTagInfoChange: (tagInfoProp: TagInfoProp) => void
  showLegalGenders: boolean
}

const TagInfoSelect = ({ onTagInfoChange, initialValue, showLegalGenders }: Props) => {
  const tagInfoOptions: SelectOption[] = [
    {
      label: i18n.t('employees.orgchart.workplace'),
      value: tagInfoProps.workplace,
    },
    {
      label: i18n.t('employees.orgchart.legal_entity'),
      value: tagInfoProps.legal_entity,
    },
    {
      label: i18n.t('employees.orgchart.hire_date'),
      value: tagInfoProps.start_day,
    },
  ]

  const adminTagInfoOptions = showLegalGenders
    ? [
        {
          label: i18n.t('employees.orgchart.legal_gender'),
          value: tagInfoProps.legal_gender,
        },
      ]
    : []

  const [active, setActive] = useState(initialValue)

  const isTagInfoProp = (value: string | TagInfoProp): value is TagInfoProp => {
    return Object.keys(tagInfoProps).includes(value)
  }

  const handleChange = (nextTagInfoProp: string | TagInfoProp) => {
    if (!isTagInfoProp(nextTagInfoProp)) {
      throw new Error(`${nextTagInfoProp} is not a valid value`)
    }

    setActive(nextTagInfoProp)
    onTagInfoChange(nextTagInfoProp)
    track(trackingEvents.orgChart.filters.change, { is_filter: nextTagInfoProp })
  }

  return (
    <Select
      options={[...tagInfoOptions, ...adminTagInfoOptions]}
      value={active}
      onChange={handleChange}
    />
  )
}

export default TagInfoSelect
